module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts-markup-popup"
  }, [_c('button', {
    staticClass: "parts-markup-popup__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close', $event)
      }
    }
  }), _c('div', {
    staticClass: "parts-markup-popup__nav"
  }, [_vm._t("nav")], 2), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2303b54","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/markup/Popup.vue
// module id = 3fc21fa73366545bf4de
// module chunks = 89